import React from "react";
import Button from "../../Components/Button";
import TextInput from "../../Components/TextInput";
import {
  ISearchparamUI,
  SearchparamStateHandler,
} from "../TableTemplate/tableTemplate";
import { OrderBookSearchParam } from "../../Interfaces/orderBookSamplingInterfaces";
import TimePicker from "../../Components/TimePicker";

const OrderBookSamplingSearchParamUI: React.FC<
  ISearchparamUI<OrderBookSearchParam>
> = ({ intialValue, onSubmit }: ISearchparamUI<OrderBookSearchParam>) => {
  return (
    <SearchparamStateHandler<OrderBookSearchParam>
      intialValue={intialValue}
      onSubmit={onSubmit}
      Form={({ searchParam, onChange, onSubmit }) => (
        <div className="w-64 flex flex-col justify-start items-start gap-2">
          <TextInput
            label="insId "
            name="insId"
            onChange={onChange}
            value={searchParam.insId?.toString() || ""}
          />

          {/* <TimePicker
            name="fromTime"
            onChange={(name, values) => onChange(name, values.ISOString)}
            value={searchParam.fromTime}
          /> */}

          <Button
            onClick={onSubmit}
            text="جستجو"
            variant="contained"
            className="mt-3 bg-sky-600"
          />
        </div>
      )}
    />
  );
};

export default OrderBookSamplingSearchParamUI;
